import { useEffect, useState } from "react";
import { Input } from "../components/Input";
import { CustomCheckbox } from "../components/Checkbox";
import { Select } from "../components/Select";
import { PrincipalButton } from "../components/PrincipalButton";
import { Button } from "../components/Button";
import {HiOutlineCheck, HiOutlineTrash, HiOutlineXMark, HiPlus, HiOutlineEye} from 'react-icons/hi2';
import {
  GridToolbarContainer,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid-pro";
import { DataGridBase } from "../components/DataGrid/DataGridBase";
import moment from "moment";
import Modal from "../components/Modal";
import api from "../api/api";
import { toast } from "react-toastify";
import { MdEdit, MdCheckCircle } from "react-icons/md";
import logo from "../assets/images/logo-sm.png";
import { HiDownload } from "react-icons/hi";
import { knowAcces } from "../utils/utils";
import { getAppUrl } from "../utils/appUrl";
export const Referenti = () => {
  const [isOpen, setIsOpen] = useState(true);
  const [utenti, setUtenti] = useState([]);
  const [utenteSel, setUtenteSel] = useState(null);
  const [utenteToDelete, setUtenteToDelete] = useState(null);
  const [teamLeaders, setTeamLeaders] = useState([]);
  const [cessati, setCessati] = useState(false);
  const [filtroRuolo, setFiltroRuolo] = useState(null);
  const isAdmin = knowAcces(["admin"]);
  const ghostLoginEnabled = isAdmin;
  const isTL    = knowAcces(["admin", "team_leader"]);
  const CRM_PERMS = [
    { key: "admin",        label: "Admin",      color: "bg-red-100 text-red-700 border-red-200" },
    { key: "team_leader",  label: "TL",         color: "bg-purple-100 text-purple-700 border-purple-200" },
    { key: "paghe",        label: "Paghe",      color: "bg-blue-100 text-blue-700 border-blue-200" },
    { key: "assunzioni",   label: "Assunzioni", color: "bg-green-100 text-green-700 border-green-200" },
    { key: "segreteria",   label: "Segreteria", color: "bg-yellow-100 text-yellow-700 border-yellow-200" },
    { key: "f24",          label: "F24",        color: "bg-orange-100 text-orange-700 border-orange-200" },
    { key: "amministrazione", label: "Amministrazione", color: "bg-slate-100 text-slate-700 border-slate-200" },
  ];
  const PARC_PERMS = [
    { key: "parc_admin",       label: "Admin",      color: "bg-red-100 text-red-700 border-red-200" },
    { key: "parc_team_leader", label: "TL",         color: "bg-purple-100 text-purple-700 border-purple-200" },
    { key: "parc_paghe",       label: "Paghe",      color: "bg-blue-100 text-blue-700 border-blue-200" },
    { key: "parc_assunzioni",  label: "Assunzioni", color: "bg-green-100 text-green-700 border-green-200" },
    { key: "parc_consulente",  label: "Consulenza", color: "bg-cyan-100 text-cyan-700 border-cyan-200" },
    { key: "parc_amministrazione", label: "Amministrazione", color: "bg-slate-100 text-slate-700 border-slate-200" },
  ];
  const PERMS = [
    ...CRM_PERMS,
    ...PARC_PERMS.map((permesso) => ({ ...permesso, label: `Parc. ${permesso.label}` })),
  ];

  const handleGhostLogin = async (utente) => {
    if (!window.confirm(`Accedere temporaneamente come ${utente.nome || utente.username}?`)) return;
    try {
      const { data } = await api.post(`/utenti/${utente.ID}/ghost-login`);
      ['accessToken', 'username', 'permission', 'pic', 'id', 'cpt_auth', 'ghostBy'].forEach((key) => {
        const source = key === 'cpt_auth' ? 'auth_cpt' : key;
        if (data[source] == null) localStorage.removeItem(key);
        else localStorage.setItem(key, data[source]);
      });
      window.location.href = getAppUrl(data.landingPage || '/Home');
    } catch (error) {
      toast.error(error.response?.data?.message || 'Ghost login non riuscito');
    }
  };

  const columns = [
    {
      field: "Azioni",
      headerName: "Azioni",
      width: 132,
      headerAlign: "center",
      align: "center",
      filterable: false,
      renderCell: (params) => (
        <div className="grid grid-cols-3 items-center justify-items-center gap-1">
          <div className="flex w-10 justify-center">
          {isTL && (
            <Button
              className="edit-button"
              type="button"
              icon={<MdEdit className="button-icon" />}
              onClick={async () => {
                await setUtenteSel(params.row);
                document.getElementById("editUtente").click();
              }}
            />
          )}
          </div>
          <div className="flex w-10 justify-center">
          {ghostLoginEnabled && params.row.admin !== 1 && Number(params.row.ID) !== Number(localStorage.getItem('id')) && (
            <Button
              className="edit-button"
              type="button"
              icon={<HiOutlineEye className="button-icon" />}
              onClick={() => handleGhostLogin(params.row)}
            />
          )}
          </div>
          <div className="flex w-10 justify-center">
          {isAdmin && (
            <Button
              className="delete-button"
              type="button"
              icon={<HiOutlineTrash className="button-icon" />}
              onClick={() => setUtenteToDelete(params.row)}
            />
          )}
          </div>
        </div>
      ),
    },
    {
      field: "nome",
      headerName: "Nome",
      flex: 1.5,
      minWidth: 140,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "username",
      headerName: "Username",
      flex: 1,
      minWidth: 110,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "email",
      headerName: "Email",
      flex: 1.5,
      minWidth: 180,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "permessi_crm",
      headerName: "Permessi CRM",
      flex: 1.6,
      minWidth: 230,
      headerAlign: "left",
      align: "left",
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <div className="flex flex-wrap gap-1 py-1">
          {CRM_PERMS.filter((p) => params.row[p.key] == 1).map((p) => (
            <span key={p.key} className={`px-2 py-0.5 rounded border text-xs font-medium ${p.color}`}>
              {p.label}
            </span>
          ))}
        </div>
      ),
    },
    {
      field: "permessi_parcellazione",
      headerName: "Permessi Parcellazione",
      flex: 1.6,
      minWidth: 250,
      headerAlign: "left",
      align: "left",
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <div className="flex flex-wrap gap-1 py-1">
          {PARC_PERMS.filter((p) => params.row[p.key] == 1).map((p) => (
            <span key={p.key} className={`px-2 py-0.5 rounded border text-xs font-medium ${p.color}`}>
              {p.label}
            </span>
          ))}
        </div>
      ),
    },
    {
      field: "data_cessazione",
      headerName: "Cessazione",
      width: 110,
      headerAlign: "center",
      align: "center",
      renderCell: (params) =>
        params.value
          ? <span className="text-xs text-red-500">{new Date(params.value).toLocaleDateString("it-IT")}</span>
          : null,
    },
  ];

  const loadUtenti = async (includi_cessati) => {
    const utenti = await api.get("/utenti");
    if (includi_cessati) {
      setUtenti(utenti.data);
      setTeamLeaders(utenti.data.filter((el) => el.team_leader == 1));
    } else {
      let utenti_no_cessati = utenti.data.filter(
        (el) => !el.data_cessazione || new Date(el.data_cessazione) > new Date()
      );
      setUtenti(utenti_no_cessati);
      setTeamLeaders(utenti.data.filter((el) => el.team_leader == 1));
    }
  };

  useEffect(() => {
    loadUtenti(false);
  }, []);

  const handleExport = async () => {
    try {
      let response = await api.post(
        `/utenti/export`,
        {},
        { responseType: "blob" }
      );

      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: "" })
      ); //prendo il file, lo rendo blob lo aggancio a un link e scarico

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "referenti.xlsx");
      document.body.appendChild(link);
      link.click();
      toast.success("download eseguito con successo");
    } catch {
      toast.error("errore nel download dei documenti");
    }
  };
  const handleChangeCheckbox = () => {
    setCessati(!cessati);
    loadUtenti(!cessati);
  };
  useEffect(() => {
    if (utenteToDelete) {
      document.getElementById("deleteOrario").click();
    }
  }, [utenteToDelete]);

  const utentiFiltrati = filtroRuolo
    ? utenti.filter((u) => u[filtroRuolo] == 1)
    : utenti;

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <div className="w-full flex flex-col gap-2 mb-2">
          <div className="flex flex-wrap gap-1.5">
            <button
              onClick={() => setFiltroRuolo(null)}
              className={`px-3 py-1 rounded text-xs font-semibold border transition-colors ${
                filtroRuolo === null
                  ? "bg-gray-700 text-white border-gray-700"
                  : "bg-white text-gray-600 border-gray-300 hover:bg-gray-50"
              }`}
            >
              Tutti
            </button>
            {PERMS.map((p) => (
              <button
                key={p.key}
                onClick={() => setFiltroRuolo(filtroRuolo === p.key ? null : p.key)}
                className={`px-3 py-1 rounded text-xs font-semibold border transition-colors ${
                  filtroRuolo === p.key
                    ? p.color.replace("100", "300") + " ring-1 ring-current"
                    : p.color + " opacity-60 hover:opacity-100"
                }`}
              >
                {p.label}
              </button>
            ))}
          </div>
          <div className="flex flex-wrap-reverse md:flex-nowrap justify-between md:space-x-5 gap-y-1">
            <div className="flex md:flex-nowrap md:w-fit w-full flex-wrap justify-center md:justify-start gap-x-2">
              <GridToolbarQuickFilter placeholder="Cerca..." />
              <CustomCheckbox
                label="Cessati"
                name="cessati"
                checked={cessati}
                onClick={(e) => handleChangeCheckbox(e)}
                value={cessati}
              />
            </div>
            <div className="flex flex-row gap-2">
              <Button
                className="principal-button"
                text="Esporta"
                type="button"
                icon={<HiDownload className="button-icon" />}
                onClick={handleExport}
              />
              <ModalUtente
                tipologia={"inserimento"}
                teamLeaders={teamLeaders}
                loadUtenti={loadUtenti}
              />
            </div>
          </div>
        </div>
      </GridToolbarContainer>
    );
  }

  return (
    <>
      <ModalUtente
        tipologia={"modifica"}
        utenteSel={utenteSel}
        loadUtenti={loadUtenti}
        teamLeaders={teamLeaders}
      />
      <DeleteUtente utente={utenteToDelete} loadUtenti={loadUtenti} />

      <div className="page-container">
        <div className="w-full el-container">
          <DataGridBase
            storageKey="referenti"
            slots={{ toolbar: CustomToolbar }}
            columns={columns}
            rows={utentiFiltrati}
            getRowId={(r) => r.ID}
            autoHeight
          />
        </div>
      </div>
    </>
  );
};

const ModalUtente = ({
  tipologia,
  utenteSel,
  tipologia_referente_esterno,
  cliente,
  dettaglio,
  loadUtenti,
  teamLeaders,
}) => {
  const [open, setOpen] = useState(false);
  const [utente, setUtente] = useState({
    referente: "",
    email_referente: "",
    tipologia: "",
  });
  const [orariDiLavoro, setOrariDiLavoro] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [orarioSel, setOrarioSel] = useState(null);
  const handleChange = (e) => {
    let u = { ...utente };
    // Se il campo è data_cessazione e il valore è vuoto, imposta NULL
    if (e.target.name === 'data_cessazione' && e.target.value === '') {
      u[e.target.name] = null;
    } else {
      u[e.target.name] = e.target.value;
    }
    setUtente(u);
  };

  const handleChangeCheckbox = (e, name) => {
    let u = { ...utente };
    if (name == "team_leader" && e.target.checked) {
      u.responsabile = 29;
    }
    u[name] = e.target.checked ? 1 : 0;
    setUtente(u);
  };

  const handleChangeSelect = (e, name) => {
    let u = { ...utente };
    u[name] = e.target.value;
    setUtente(u);
  };

  const loadOrariDiLavoro = async (utente) => {
    console.log(utente);
    const orari = await api.get(`/orario_lavoro/${utente}`);
    setOrariDiLavoro(orari.data);
  };

  const handleClickOpen = async () => {
    if (tipologia === "modifica") {
      const res = await api.get(`/utenti/${utenteSel.ID}`);
      setUtente(res.data[0]);
      await loadOrariDiLavoro(utenteSel.ID);
    } else {
      setUtente({ referente: "", email_referente: "", tipologia: "" });
      setOrariDiLavoro([]);
    }

    setOpen(true);
  };

  const handleImage = async (e) => {
    const img = e.target.files[0];
    var reader = new FileReader();
    reader.readAsDataURL(img);
    reader.onload = function () {
      console.log(reader.result);

      let u = { ...utente };
      u.pic = reader.result;
      setUtente(u);

      // document.getElementById("firmaFormatore").src = reader.result;
      /*  let f = { ...pittogramma };
       let foto = reader.result.replace("data:image/jpeg;base64,", "");
       foto = foto.replace("data:image/png;base64,", "");
       f.Immagine = foto; */
      //setPittogramma(f);
    };
    reader.onerror = function (error) {
      console.log("Error: ", error);
    };
  };

  const handleSave = async () => {
    try {
      if (tipologia === "inserimento") {
        let savePayroll = await api.post("/utenti", { user: utente });
        toast.success("Inserito con successo. Password di default: Miller123!");
      } else if (tipologia === "modifica") {
        let updateUser = await api.put("/utenti", { user: utente });

        toast.success("modificato con successo");
      }

      /*  if(tipologia ==="elimina"){
         let savePayroll = await api.delete(`/referenti_aziende_esterno/${dettaglioEmail.ID}`,)

         toast.success("eliminato con successo")
       } */

      loadUtenti();
    } catch {
      toast.error("errore durante il salvataggio");
    }
  };

  const handleResetPassword = async () => {
    try {
      if (!utente?.ID) {
        toast.error("Utente non valido");
        return;
      }

      const confirmed = window.confirm(
        `Sei sicuro di voler resettare la password di ${utente.username} a "Miller123!"?`
      );

      if (!confirmed) return;

      await api.put(`/utenti/${utente.ID}/reset-password`);
      toast.success(`Password resettata con successo a "Miller123!"`);
    } catch (err) {
      console.error("Error resetting password:", err);
      if (err.response?.status === 403) {
        toast.error("Accesso negato. Solo admin e team leader possono resettare le password.");
      } else {
        toast.error("Errore durante il reset della password");
      }
    }
  };

  const columns = [
    {
      field: "Azioni",
      headerName: "Azioni",

      headerAlign: "center",
      align: "center",
      filterable: false,
      renderCell: (params) => {
        return (
          <>
            <Button
              className="edit-button "
              type="button"
              icon={<MdEdit className="button-icon" />}
              onClick={async () => {
                await setOrarioSel(params.row);
                document.getElementById("editOrario").click();
              }}
            />
            <Button
              className="delete-button"
              type="button"
              icon={<HiOutlineTrash className="button-icon" />}
              onClick={async () => {
                await setOrarioSel(params.row);
                document.getElementById("deleteOrario").click();
                //await setReferente(params.row);

                //document.getElementById("deleteEmail").click();
              }}
            />{" "}
          </>
        );
      },
    },
    {
      field: "percentuale_orario",
      headerName: "Percentuale orario",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },

    {
      field: "data_validita",
      headerName: "Data validità",
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params) =>
        moment(params.row.data_validita).format("DD/MM/YYYY"),
    },
  ];

  return (
    <>
      {tipologia === "inserimento" ? (
        <Button
          className="principal-button "
          text="Aggiungi"
          type="button"
          icon={<HiPlus className="button-icon" />}
          onClick={async () => {
            setOpen(true);
          }}
        />
      ) : tipologia === "modifica" ? (
        <Button
          className=" hidden"
          id="editUtente"
          type="button"
          icon={<MdEdit className="button-icon" />}
          onClick={async () => {
            handleClickOpen();
          }}
        />
      ) : (
        <Button
          className=" hidden"
          id="deleteEmail"
          type="button"
          icon={<MdEdit className="button-icon" />}
          onClick={async () => {
            handleClickOpen();
          }}
        />
      )}
      <Modal
        isOpen={open}
        closeButton={() => setOpen(false)}
        size="medium"
        headerText={
          tipologia +
          ` Referente` +
          (tipologia === "inserimento" ? "" : " - " + utente?.username)
        }
        leftButtons={
          <div className="flex gap-2">
            <Button
              className="principal-button z-[110]"
              text={tipologia === "elimina" ? "Elimina" : "Salva"}
              type="button"
              icon={<HiOutlineCheck className="button-icon" />}
              onClick={async () => {
                handleSave();
              }}
            />
            {tipologia === "modifica" && knowAcces(["admin", "team_leader"]) && (
              <Button
                className="principal-button z-[110] bg-orange-500 hover:bg-orange-600"
                text="Reset Password"
                type="button"
                onClick={handleResetPassword}
              />
            )}
          </div>
        }
      >
        <DeleteOrarioDiLavoro
          utente={utenteSel}
          tipologia={"Modifica"}
          orarioSel={orarioSel}
          loadOrariDiLavoro={loadOrariDiLavoro}
        />
        <div className="grid grid-cols-4 gap-2">
          <div className="col-span-4 content-center text-center">
            <img
              alt="user 5"
              src={utente?.pic ? utente.pic : logo}
              onClick={() => document.getElementById("fileUploader").click()}
              className="relative inline-block h-48 w-48 rounded-full border-2 border-primary object-cover object-center hover:z-10 focus:z-10 hover:opacity-75 hover:cursor-pointer transition delay-150"
            />
            <input
              type="file"
              id="fileUploader"
              className="hidden"
              accept="image/png"
              onChange={(e) => handleImage(e)}
            />
          </div>

          <div className="col-span-2 md:col-span-1">
            <Input
              type="text"
              label={"nome"}
              name="nome"
              onChange={(e) => handleChange(e)}
              value={utente?.nome}
              disabled={false}
            />
          </div>
          <div className="col-span-2 md:col-span-1">
            <Input
              type="text"
              label={"username"}
              name="username"
              onChange={(e) => handleChange(e)}
              value={utente?.username}
              disabled={false}
            />
          </div>

          <div className="col-span-4 md:col-span-2">
            <Input
              type="text"
              label={"email"}
              name="email"
              onChange={(e) => handleChange(e)}
              value={utente?.email}
              disabled={false}
            />
          </div>
          <div className="col-span-2 md:col-span-1">
            <Input
              type="text"
              label={"Codice Zucchetti"}
              name="codice_zucchetti"
              onChange={(e) => handleChange(e)}
              value={utente?.codice_zucchetti}
              disabled={false}
            />
          </div>
          <div className="col-span-2 md:col-span-1">
            <Input
              type="date"
              label={"Data cessazione"}
              name="data_cessazione"
              onChange={(e) => handleChange(e)}
              value={
                utente?.data_cessazione
                  ? moment(utente.data_cessazione).format("YYYY-MM-DD")
                  : ""
              }
              disabled={false}
              showClear={true}
              onClear={() => {
                let u = { ...utente };
                u.data_cessazione = null;
                setUtente(u);
              }}
            />
          </div>
          {/* <div className="col-span-4 md:col-span-2">

            <Select
              type="text"
              label={"Tipologia utente"}
              name="permission"
              onChange={(e) => handleChangeSelect(e, "permission")}
              value={utente?.permission}
              placeholder="Seleziona..."
              options={[{ id: "1", name: "Admin" }, { id: "2", name: "Responsabile" }, { id: "3", name: "Paghe" }, { id: "4", name: "Assunzioni" }]}
              disabled={false}
            />

          </div> */}
          <div className="col-span-4 md:col-span-2">
            <Select
              type="text"
              label={"Team Leader"}
              name="responsabile"
              onChange={(e) => handleChangeSelect(e, "responsabile")}
              value={utente?.responsabile}
              placeholder="Seleziona..."
              options={teamLeaders.map((el) => {
                return { id: el.ID, name: el.nome };
              })}
              disabled={utente.team_leader == 1}
            />
          </div>

          <div className="col-span-4 grid grid-cols-1 gap-3 md:grid-cols-2">
            <div className="rounded-lg border border-slate-200 bg-slate-50 p-3">
              <div className="mb-2 text-xs font-semibold uppercase tracking-wide text-slate-500">Permessi CRM</div>
              <div className="flex flex-wrap items-center gap-x-3 gap-y-2">
            <CustomCheckbox
              label={"Team Leader"}
              name="team_leader"
              onClick={(e) => handleChangeCheckbox(e, "team_leader")}
              value={utente?.team_leader}
            />
            <CustomCheckbox
              label={"Paghe"}
              name="paghe"
              onClick={(e) => handleChangeCheckbox(e, "paghe")}
              value={utente?.paghe}
            />
            <CustomCheckbox
              label={"Assunzioni"}
              name="assunzioni"
              onClick={(e) => handleChangeCheckbox(e, "assunzioni")}
              value={utente?.assunzioni}
            />
            <CustomCheckbox
              label={"Segreteria"}
              name="segreteria"
              onClick={(e) => handleChangeCheckbox(e, "segreteria")}
              value={utente?.segreteria}
            />
            <CustomCheckbox
              label={"F24"}
              name="f24"
              onClick={(e) => handleChangeCheckbox(e, "f24")}
              value={utente?.f24}
            />
            <CustomCheckbox
              label={"Admin"}
              name="admin"
              onClick={(e) => handleChangeCheckbox(e, "admin")}
              value={utente?.admin}
            />
            <CustomCheckbox
              label={"Amministrazione"}
              name="amministrazione"
              onClick={(e) => handleChangeCheckbox(e, "amministrazione")}
              value={utente?.amministrazione}
            />
              </div>
            </div>
            <div className="rounded-lg border border-blue-200 bg-blue-50/50 p-3">
              <div className="mb-2 text-xs font-semibold uppercase tracking-wide text-blue-600">Permessi Parcellazione</div>
              <div className="flex flex-wrap items-center gap-x-3 gap-y-2">
                <CustomCheckbox label={"Admin"} name="parc_admin"
                  onClick={(e) => handleChangeCheckbox(e, "parc_admin")} value={utente?.parc_admin} />
                <CustomCheckbox label={"Team Leader"} name="parc_team_leader"
                  onClick={(e) => handleChangeCheckbox(e, "parc_team_leader")} value={utente?.parc_team_leader} />
                <CustomCheckbox label={"Paghe"} name="parc_paghe"
                  onClick={(e) => handleChangeCheckbox(e, "parc_paghe")} value={utente?.parc_paghe} />
                <CustomCheckbox label={"Assunzioni"} name="parc_assunzioni"
                  onClick={(e) => handleChangeCheckbox(e, "parc_assunzioni")} value={utente?.parc_assunzioni} />
                <CustomCheckbox label={"Consulenza"} name="parc_consulente"
                  onClick={(e) => handleChangeCheckbox(e, "parc_consulente")} value={utente?.parc_consulente} />
                <CustomCheckbox label={"Amministrazione"} name="parc_amministrazione"
                  onClick={(e) => handleChangeCheckbox(e, "parc_amministrazione")} value={utente?.parc_amministrazione} />
              </div>
            </div>
            {/*<CustomCheckbox*/}
            {/*  label={"Amministrazione"}*/}
            {/*  name="amministrazione"*/}
            {/*  onClick={(e) => handleChangeCheckbox(e, "amministrazione")}*/}
            {/*  value={utente?.amministrazione}*/}
            {/*/>*/}
          </div>

          {tipologia === "modifica" && (
            <>
              <div className="col-span-3">Orario di lavoro</div>
              <div className="col-span-1">
                <ModalOrarioDiLavoro
                  utente={utenteSel}
                  tipologia={"inserimento"}
                  loadOrariDiLavoro={loadOrariDiLavoro}
                />
                <ModalOrarioDiLavoro
                  utente={utenteSel}
                  tipologia={"Modifica"}
                  orarioSel={orarioSel}
                  loadOrariDiLavoro={loadOrariDiLavoro}
                />
              </div>
              <div className="col-span-4 border rounded-md overflow-hidden">
                <table className="w-full text-xs">
                  <thead>
                    <tr className="bg-gray-100 text-gray-600 uppercase tracking-wide">
                      <th className="px-3 py-1.5 text-center font-medium w-20">Azioni</th>
                      <th className="px-3 py-1.5 text-center font-medium">Percentuale orario</th>
                      <th className="px-3 py-1.5 text-center font-medium">Data validità</th>
                    </tr>
                  </thead>
                  <tbody>
                    {orariDiLavoro.length === 0 ? (
                      <tr><td colSpan={3} className="text-center py-4 text-gray-400 italic">Nessun record</td></tr>
                    ) : (
                      orariDiLavoro.map((o) => (
                        <tr key={o.ID} className="border-t border-gray-100 hover:bg-gray-50">
                          <td className="px-2 py-1">
                            <div className="flex gap-1 justify-center">
                              <Button className="edit-button" type="button" icon={<MdEdit className="button-icon" />}
                                onClick={() => { setOrarioSel(o); document.getElementById("editOrario").click(); }} />
                              <Button className="delete-button" type="button" icon={<HiOutlineTrash className="button-icon" />}
                                onClick={() => { setOrarioSel(o); document.getElementById("deleteOrario").click(); }} />
                            </div>
                          </td>
                          <td className="px-3 py-1 text-center">{o.percentuale_orario}%</td>
                          <td className="px-3 py-1 text-center">{o.data_validita ? new Date(o.data_validita).toLocaleDateString("it-IT") : "—"}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </div>
      </Modal>
    </>
  );
};

const ModalOrarioDiLavoro = ({
  utente,
  tipologia,
  orarioSel,
  loadOrariDiLavoro,
}) => {
  const [orario, setOrario] = useState(null);
  const [openModal, setOpenModal] = useState(false);

  const handleChange = (e) => {
    let o = { ...orario };
    o[e.target.name] = e.target.value;
    setOrario(o);
  };

  const handleOpenModal = () => {
    if (tipologia === "inserimento") {
      setOrario({ percentuale_orario: "", data_validita: null });
    } else {
      console.log(orarioSel.data_validita.toString());
      setOrario(orarioSel);
    }
    setOpenModal(true);
  };

  const handleSave = async () => {
    // Validazioni
    if (!orario?.percentuale_orario || orario.percentuale_orario === "") {
      toast.error("Inserire la percentuale orario");
      return;
    }

    const percentuale = parseFloat(orario.percentuale_orario);
    if (isNaN(percentuale) || percentuale < 10 || percentuale > 100) {
      toast.error("La percentuale orario deve essere tra 10 e 100");
      return;
    }

    if (!orario?.data_validita) {
      toast.error("Inserire la data di validità");
      return;
    }

    try {
      if (tipologia === "inserimento") {
        let o = { ...orario };
        o.utente = utente.ID;

        await api.post("/orario_lavoro", { orario: o });
        toast.success("Orario inserito con successo");
      } else {
        await api.put("/orario_lavoro", { orario: orario });

        toast.success("Orario modificato con successo");
      }
      setOpenModal(false)
      await loadOrariDiLavoro(utente.ID);
    } catch {
      toast.error("Errore durante il salvataggio");
    }
  };

  return (
    <>
      {tipologia === "inserimento" ? (
        <Button
          className="success-button"
          text="Aggiungi"
          type="button"
          icon={<HiPlus className="button-icon" />}
          onClick={async () => {
            handleOpenModal();
          }}
        />
      ) : (
        <Button
          className="edit-button invisible"
          id="editOrario"
          type="button"
          icon={<MdEdit className="button-icon" />}
          onClick={async () => {
            handleOpenModal();
          }}
        />
      )}

      <Modal
        isOpen={openModal}
        closeButton={() => setOpenModal(false)}
        headerText="Inserisci Orario di lavoro"
        size="small"
        leftButtons={
          <Button
            className="principal-button"
            text="Salva"
            type="button"
            icon={<HiOutlineCheck className="button-icon" />}
            onClick={async () => {
              handleSave();
            }}
          />
        }
      >
        <Input
          type="number"
          label={"Percentuale Orario"}
          name="percentuale_orario"
          onChange={(e) => handleChange(e)}
          value={orario?.percentuale_orario}
          disabled={false}
          maxlength={3}
          max={100}
          min={10}
          required={true}
        />
        <Input
          type="date"
          label={"Data di validità"}
          name="data_validita"
          onChange={(e) => handleChange(e)}
          value={
            orario?.data_validita
              ? moment(orario.data_validita).format("YYYY-MM-DD")
              : null
          }
          disabled={false}
          required={true}
        />
      </Modal>
    </>
  );
};

const DeleteOrarioDiLavoro = ({
  utente,
  tipologia,
  orarioSel,
  loadOrariDiLavoro,
}) => {
  const [orario, setOrario] = useState(null);
  const [openModal, setOpenModal] = useState(false);

  const handleChange = (e) => {
    let o = { ...orario };
    o[e.target.name] = e.target.value;
    setOrario(o);
  };

  const handleOpenModal = () => {
    console.log(orarioSel);
    setOrario(orarioSel);
    setOpenModal(true);
  };

  const handleSave = async () => {
    try {
      await api.delete(`/orario_lavoro/${orario.ID}`);
      await loadOrariDiLavoro(utente.ID);

      setOpenModal(false);
      toast.success("Orario eliminato con successo");
    } catch (e) {
      console.log(e);
      toast.error("Errore durante la cancellazione dell'orario");
    }
  };

  return (
    <>
      <Button
        className="edit-button invisible"
        id="deleteOrario"
        type="button"
        icon={<MdEdit className="button-icon" />}
        onClick={async () => {
          handleOpenModal();
        }}
      />

      <Modal
        isOpen={openModal}
        closeButton={() => setOpenModal(false)}
        headerText="Inserisci Orario di lavoro"
        size="small"
        leftButtons={
          <Button
            className="principal-button"
            text="Conferma"
            type="button"
            icon={<HiOutlineCheck className="button-icon" />}
            onClick={async () => {
              handleSave();
            }}
          />
        }
      >
        Sei sicuro di voler eliminare l'orario di lavoro selezionato?
      </Modal>
    </>
  );
};

const DeleteUtente = ({ utente, loadUtenti }) => {
  const [openModal, setOpenModal] = useState(false);

  const handleOpenModal = () => {
    setOpenModal(true);
  };
  const handleSave = async () => {
    try {
      await api.put(`/utenti/disattiva/${utente.ID}`);
      loadUtenti();
      setOpenModal(false);
      toast.success("Utente eliminato con successo");
    } catch (e) {
      console.log(e);
      toast.error("Errore durante la cancellazione dell'orario");
    }
  };
  return (
    <>
      {/*

    <Button
              className="delete-button"
              type="button"
              icon={<HiOutlineTrash className="button-icon" />}
              onClick={async () => {
                await setOrarioSel(params.row);
                document.getElementById("deleteOrario").click();
                //await setReferente(params.row);

                //document.getElementById("deleteEmail").click();
              }}
            />{" "}
    */}
      <Button
        className="edit-button invisible"
        id="deleteOrario"
        type="button"
        icon={<MdEdit className="button-icon" />}
        onClick={handleOpenModal}
      />

      <Modal
        isOpen={openModal}
        closeButton={() => setOpenModal(false)}
        headerText="elimina utente"
        size="small"
        leftButtons={
          <Button
            className="principal-button"
            text="Conferma"
            type="button"
            icon={<HiOutlineCheck className="button-icon" />}
            onClick={async () => {
              handleSave();
            }}
          />
        }
      >
        Sei sicuro di voler eliminare {utente?.nome} ?
      </Modal>
    </>
  );
};
